<template>
  <div class="entity">
    <h1>404 Not Found</h1>
  </div>
</template>
<style lang="less" scoped>
.entity {
  height: 400px;
}
</style>